import { render } from "./AppFooter.html?vue&type=template&id=1e7afa80&scoped=true&ts=true&external"
import script from "./AppFooter.vue?vue&type=script&lang=ts"
export * from "./AppFooter.vue?vue&type=script&lang=ts"

import "./AppFooter.scss?vue&type=style&index=0&id=1e7afa80&lang=scss&scoped=true&external"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1e7afa80"]])

export default __exports__